import { c as _c } from "react/compiler-runtime";
import { FormSelect, getLocaleLanguage, useTranslation as useUiTranslation } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerWebsiteEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { FormSelectWithGroups } from 'shared/components/form-select/form-select-with-groups';
interface TriggerBlogItemProps extends EditTriggerItemInterface<TriggerWebsiteEditInterface> {}
export const TriggerWebsiteItem = t0 => {
  const $ = _c(17);
  const {
    triggers,
    trigger,
    idx,
    onDelete,
    setRules,
    errors,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== tUi || $[9] !== trigger.id || $[10] !== trigger.website || $[11] !== triggers) {
    t2 = t3 => {
      const {
        renderTriggerLabel,
        data,
        onOpen
      } = t3;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.website_form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.automation_rule.website_title")
        })} placeholder={t("dashboard.automation_rule.choose_website")} value={trigger.website.id} staticData={getDataFromObj(trigger.website)} data={data.websiteData} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  website: {
                    id: data_0,
                    websitePage: {
                      id: undefined,
                      name: undefined
                    }
                  }
                };
              } else {
                return el;
              }
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.websiteId?.join("")} />{trigger.website.id && <FormSelectWithGroups disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.website_form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.automation_rule.website_page_title")
        })} placeholder={t("dashboard.automation_rule.choose_website_page")} value={trigger.website.websitePage.pageContentId} staticData={getDataFromObj({
          id: trigger.website.websitePage.pageContentId,
          name: trigger.website.websitePage.name
        })} data={data.websitePageData ?? []} groups={data.websitePageData?.map(websitePage => ({
          id: websitePage.group,
          caption: getLocaleLanguage(websitePage.group, tUi)
        })) ?? []} onChange={data_1 => {
          setRules(prev_0 => ({
            ...prev_0,
            triggers: triggers.map((el_0, i_0) => {
              if (idx !== i_0) {
                return el_0;
              }
              if (el_0.type === AutomationRuleTriggersEnum.website_form_subscribed) {
                return {
                  ...el_0,
                  website: {
                    ...el_0.website,
                    websitePage: {
                      pageContentId: data_1
                    }
                  }
                };
              }
              return el_0;
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.page?.join("")} required={true} />}</>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = tUi;
    $[9] = trigger.id;
    $[10] = trigger.website;
    $[11] = triggers;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[13] = t1;
    $[14] = t2;
    $[15] = trigger;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};